"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUUID = exports.API = void 0;

var _uuid = require("uuid");

// import uuidv1 from 'uuid/v1';
var URL_API = '/cliente/api/';
var NODE_ENV = process.env.NODE_ENV;

if (NODE_ENV === 'development') {
  if (sessionStorage && sessionStorage.getItem('devEnvironment') === 'INTE') {
    // Entorno de integración
    URL_API = 'http://tehrhadx.serv.dev.dc.es.telefonica:11010/cliente/api/';
  } else {
    // Entorno de certificación
    URL_API = 'http://tehrhad5.serv.test.dc.es.telefonica:11010/cliente/api/';
  } // Entorno de produccion
  // URL_API = 'https://tcolgranja1.es.telefonica/cliente/api/';

} else if (typeof window === 'undefined' || window.location.href.indexOf('movistar.es.cert') === -1 && window.location.href.indexOf('movistar.es.inte') === -1 && window.location.href.indexOf('tcolgranja1.es.telefonica') === -1 && window.location.href.indexOf('tcolgranja2.es.telefonica') === -1) {
  URL_API = 'https://www.movistar.es/cliente/api/';
} // const { host, protocol } = window.location;


var URL_API_SECURITY = URL_API.replace('api/', '');
var URL_API_MOCK = 'https://europe-west1-mov-dev6.cloudfunctions.net/mooks-storage?url=telcoApis/';
var API = {
  // CUSTOMIZER
  CUSTOMIZER: {
    GET_BY_NAME: '/cms/:kind/getByName',
    GET_SEO_BY_OBJ: '/api/seo/get',
    GET_INFO_RECOM: '/perso/getInfoRecom'
  },
  // TELCO
  USER: {
    INIT: "".concat(URL_API_SECURITY, "inicio"),
    UPGRADE: "".concat(URL_API, "gestioncredenciales/upgrade"),
    LOGOUT: "".concat(URL_API, "gestioncredenciales/logout")
  },
  CATALOG: {
    GET_CATALOG_SECTIONS: "".concat(URL_API, "catalogo/secciones"),
    GET_CATALOG_SECTIONS_MOCK: "".concat(URL_API_MOCK, "catalog/getCatalogSections.json"),
    GET_CATALOG_SUBSECTION: "".concat(URL_API, "catalogo/subseccion"),
    GET_CATALOG_SUBSECTION_MOCK: "".concat(URL_API_MOCK, "catalog/getCatalogSubsection.json"),
    GET_PRODUCT_OFFERING: "".concat(URL_API, "catalogo/oferta"),
    GET_PRODUCT_OFFERING_MOCK: "".concat(URL_API_MOCK, "catalog/getProductOffering.json"),
    GET_PRODUCT_OFFERING_ATTACHMENTS: "".concat(URL_API, "catalogo/documentos"),
    GET_PRODUCT_OFFERING_ATTACHMENTS_MOCK: "".concat(URL_API_MOCK, "catalog/getProductOfferingAttachments.json")
  },
  CLIENT: {
    MY_DATA: "".concat(URL_API, "datoscliente/misdatos"),
    MY_DATA_MOCK: "".concat(URL_API_MOCK, "client/myData.json"),
    MY_CONTACTS: "".concat(URL_API, "datoscliente/misdatos/contacto"),
    MY_CONTACTS_MOCK: "".concat(URL_API_MOCK, "client/myContacts.json"),
    UPDATE_CONTACTS_MOCK: "".concat(URL_API_MOCK, "client/updateContacts.json"),
    MY_DATA_OTHERS: "".concat(URL_API, "datoscliente/otrosdatos"),
    MY_DATA_OTHERS_MOCK: "".concat(URL_API_MOCK, "client/myDataOthers.json")
    /* QUERYPARAMETERS productId (se obtiene de la api X) */

  },
  // Bills
  BILLS: {
    /* DETAILS: `${URL_API}facturas/misfacturas/{billNo}/detalle/`,
    DOWNLOAD: `${protocol}//${host}/cliente/api/facturas/misfacturas/{billNo}/{billType}/descarga/`,
    DUPLICATE: `${URL_API}facturas/misfacturas/{billNo}/duplicado/`,
    LIST: `${URL_API}facturas/misfacturas/listado`*/
    GET_BILLING_DATE: "".concat(URL_API, "facturas/misfacturas/account/{accountId}/fechas"),
    GET_BILLING_DATE_MOCK: "".concat(URL_API_MOCK, "bills/getBillingDate.json")
  },

  /*
  // Usages
  USAGE: {
  ACCUMULATED_INTE: `${URL_API}consumos/misconsumos/acumulado`,
  DETAILED_INTE: `${URL_API}consumos/misconsumos/detallado`
  },
  // Third Parties
  THIRD_PARTIES: {
  SECURE_CONNECTION: `${URL_API}servicios/misservicios/sso/conexionsegura`,
  NETFLIX: `${URL_API}servicios/misservicios/netflix/activacion`,
  LIST: `${URL_API}productos/serviciosterceros`,
  GOTO_ALEJANDRA: `${URL_API}servicios/router/gestion/sso`,
  UPDATE: `${URL_API}pedidos/expres`
  },
  MONITORING: {
  SEND_ERROR: `${URL_API}monitorizacion/js`
  },
  BREAKDOWN: {
  GET_PERMISSION: `${URL_API}averias/alta/permiso`,
  REASON: `${URL_API}averias/alta/sintomas`,
  OPEN: `${URL_API}averias/alta/registrar`,
  TRACKING: `${URL_API}averias/seguimiento/listado`,
  NUMBER: `${URL_API}averias/seguimiento/abiertas`
  },
  CONSENTS: {
  GET_LIST: `${URL_API}consentimientos/misconsentimientos/listado`,
  SAVE: `${URL_API}consentimientos/misconsentimientos/gestion`
  },
  SALES: {
  // proximo cambio de /apertura --> /manual
  OPEN_MANUAL: `${URL_API}servicios/workflow/manual`,
  OPEN_AUTO: `${URL_API}servicios/workflow/automatico`,
  GET_TELCO_INFO_FROM_ION: 'https://mov-mantix-dot-mov-prod1.appspot.com/mtx/sc/telco/campaign',
  GET_TELCO_INFO_FROM_PO: `${URL_API}productos/detalle`
  },*/
  TV: {
    DISNEY_COMPATIBILITY: "".concat(URL_API, "servicios/misservicios/disney"),
    DISNEY_COMPATIBILITY_MOCK: "".concat(URL_API_MOCK, "tv/getDisneyCompatibility.json"),
    DISNEY_ACTIVATION: "".concat(URL_API, "servicios/misservicios/disney/activacion"),
    DISNEY_ACTIVATION_MOCK: "".concat(URL_API_MOCK, "tv/disneyActivation.json"),
    GET_RECOMMENDED_TV: "".concat(URL_API, "productos/misproductos/tv/{administrativeNumber}/recomendados"),
    GET_RECOMMENDED_TV_MOCK: "".concat(URL_API_MOCK, "tv/getRecommendedTV.json")
  },
  PRODUCTS: {
    MY_PRODUCTS_INTE: "".concat(URL_API, "productos/misproductos"),
    MY_PRODUCTS_INTE_MOCK: "".concat(URL_API_MOCK, "product/myProduct.json"),
    MY_PRODUCTS_TREE: "".concat(URL_API, "productos/misproductos/tree"),
    MY_PRODUCTS_TREE_MOCK: "".concat(URL_API_MOCK, "product/myProductNew.json"),
    MY_TARIFF_INFO: "".concat(URL_API, "productos/detalle"),
    MY_LINES: "".concat(URL_API, "productos/misproductos/lineas"),
    MY_THIRD_PRODUCTS: "".concat(URL_API, "productos/serviciosterceros"),
    MY_THIRD_PRODUCTS_MOCK: "".concat(URL_API_MOCK, "cqv2/getServiciosTerceros.json"),
    GET_SMART_WIFI_STATUS: "".concat(URL_API, "productos/serviciosterceros/smartwifi/estado"),
    GET_SMART_WIFI_STATUS_MOCK: "".concat(URL_API_MOCK, "product/getSmartWiFiStatus.json"),
    GET_DEVICES_CONNECTED_SMART_WIFI: "".concat(URL_API, "productos/serviciosterceros/smartwifi/dispositivos"),
    GET_DEVICES_CONNECTED_SMART_WIFI_MOCK: "".concat(URL_API_MOCK, "product/getDevicesConnectedSmartWiFi.json"),
    GET_SECURE_CONNECTION_STATUS: "".concat(URL_API, "productos/serviciosterceros/cxsegura/estado"),
    GET_SECURE_CONNECTION_STATUS_MOCK: "".concat(URL_API_MOCK, "product/getSecureConnectionStatus.json"),
    GET_MOBILE_CONFIGURATION_STATUS: "".concat(URL_API, "servicios/gestionlinea/estado"),
    GET_MOBILE_CONFIGURATION_STATUS_MOCK: "".concat(URL_API_MOCK, "product/getMobileConfigurationStatus.json"),
    CHANGE_MOBILE_CONFIGURATION: "".concat(URL_API, "servicios/gestionlinea/updateGestionLinea"),
    CHANGE_MOBILE_CONFIGURATION_MOCK: "".concat(URL_API_MOCK, "product/changeMobileConfiguration.json")
  },
  MAP: {
    ADDRESS: "".concat(URL_API, "pedidos/callejero"),
    ADDRESS_MOCK: "".concat(URL_API_MOCK, "addresses/address.json")
  },
  CQ: {
    VALIDATE_TERMINAL: "".concat(URL_API, "pedidos/validacion/terminal"),
    VALIDATE_TERMINAL_MOCK: "".concat(URL_API_MOCK, "terminal/validateTerminal.json"),
    UPDATE_CQ: "".concat(URL_API, "pedidos/CQ/{cq}/actualizar"),
    UPDATE_CQ_MOCK: "".concat(URL_API_MOCK, "cq/updateCq.json"),
    INIT_CARD_PAYMENT: "".concat(URL_API, "pedidos/inicio/tarjeta"),
    INIT_CARD_PAYMENT_MOCK: "".concat(URL_API_MOCK, "cq/initCardPayment.json"),
    INIT_FRACTIONATED_PAYMENT: "".concat(URL_API, "pedidos/inicio/fraccionado"),
    INIT_FRACTIONATED_PAYMENT_MOCK: "".concat(URL_API_MOCK, "cq/initFractionatedPayment.json"),
    INIT_FINANCIATED_PAYMENT: "".concat(URL_API, "pedidos/inicio/financiacion"),
    INIT_FINANCIATED_PAYMENT_MOCK: "".concat(URL_API_MOCK, "cq/initFinanciatedPayment.json"),
    // ACCEPT_CARD_PAYMENT: `${URL_API}pedidos/pago/aceptado`,
    // REJECT_CARD_PAYMENT: `${URL_API}pedidos/pago/rechazado`,
    LIST_CQ: "".concat(URL_API, "pedidos/CQ"),
    LIST_CQ_MOCK: "".concat(URL_API_MOCK, "cq/listCq.json"),
    REJECT_FINANCIATED_PAYMENT: "".concat(URL_API, "pedidos/financiacion/rechazada"),
    TERMS_AND_CONDITIONS: "".concat(URL_API, "pedidos/legales"),
    TERMS_AND_CONDITIONS_MOCK: "".concat(URL_API_MOCK, "terminal/termsAndConditions.html"),
    STATUS_FINANCIATED_PAYMENT: "".concat(URL_API, "pedidos/financiacion/status"),
    STATUS_FINANCIATED_PAYMENT_MOCK: "".concat(URL_API_MOCK, "cq/statusFinanciatedPayment.json")
  },
  CQV2: {
    INIT_CQ: "".concat(URL_API, "ventas/inicializar/pedido"),
    INIT_CQ_MOCK: "".concat(URL_API_MOCK, "cqv2/initCQ.json"),
    INIT_CQ_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/initCQ.json"),
    SELECT_ELEMENTS: "".concat(URL_API, "ventas/configurar/{cq}/elegir/elementos"),
    SELECT_ELEMENTS_MOCK: "".concat(URL_API_MOCK, "cqv2/selectElements.json"),
    SELECT_ELEMENTS_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/selectElements.json"),
    GET_FEATURES: "".concat(URL_API, "ventas/configurar/{cq}/recuperar/caracteristicas"),
    GET_FEATURES_MOCK: "".concat(URL_API_MOCK, "cqv2/getFeatures.json"),
    GET_FEATURES_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/getFeatures.json"),
    ADD_TO_CART: "".concat(URL_API, "ventas/configurar/{cq}/agregar/alcarro"),
    ADD_TO_CART_MOCK: "".concat(URL_API_MOCK, "cqv2/addToCart.json"),
    ADD_TO_CART_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/addToCart.json"),
    EXTEND_CQ: "".concat(URL_API, "ventas/configurar/{cq}/ampliar"),
    EXTEND_CQ_MOCK: "".concat(URL_API_MOCK, "cqv2/extendCQ.json"),
    CANCEL_CQ: "".concat(URL_API, "ventas/finalizar/{cq}/cancelar"),
    CANCEL_CQ_MOCK: "".concat(URL_API_MOCK, "cqv2/cancelCQ.json"),
    GENERATE_PIN: "".concat(URL_API, "ventas/pin/generar"),
    GENERATE_PIN_MOCK: "".concat(URL_API_MOCK, "cqv2/generatePIN.json"),
    CHECK_PIN: "".concat(URL_API, "ventas/pin/comprobar"),
    CHECK_PIN_MOCK: "".concat(URL_API_MOCK, "cqv2/checkPIN.json"),
    UPDATE_CQ: "".concat(URL_API, "ventas/configurar/{cq}/actualizar/info"),
    GET_CQ_PRICES: "".concat(URL_API, "ventas/configurar/{cq}/recuperar/precios"),
    GET_CQ_PRICES_MOCK: "".concat(URL_API_MOCK, "cqv2/getCQPrices.json"),
    UPDATE_CQ_MOCK: "".concat(URL_API_MOCK, "cqv2/updateCQ.json"),
    UPDATE_CQ_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/updateCQ.json"),
    CONFIRM_CQ: "".concat(URL_API, "ventas/finalizar/{cq}/confirmar"),
    CONFIRM_CQ_MOCK: "".concat(URL_API_MOCK, "cqv2/confirmCQ.json"),
    GET_LEGAL_TERMS: "".concat(URL_API, "ventas/finalizar/{cq}/recuperar/legales"),
    GET_LEGAL_TERMS_MOCK: "".concat(URL_API_MOCK, "cqv2/getLegalTerms.json"),
    GET_LEGAL_TERMS_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/getLegalTerms.json"),
    GET_POTS: "".concat(URL_API, "ventas/configurar/{cq}/recuperar/medios"),
    GET_POTS_MOCK: "".concat(URL_API_MOCK, "cqv2/getPOTS.json"),
    GET_POTS_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/getPOTS.json"),
    CANCEL_ALL: "".concat(URL_API, "ventas/finalizar/cancelar/todas"),
    CANCEL_ALL_MOCK: "".concat(URL_API, "cqv2/cancelAll.json"),
    INIT_CARD_PAYMENT: "".concat(URL_API, "ventas/pago/{cq}/tarjeta"),
    INIT_CARD_PAYMENT_MOCK: "".concat(URL_API_MOCK, "cq/initCardPayment.json"),
    INIT_FINANCIATED_PAYMENT: "".concat(URL_API, "ventas/pago/{cq}/financiado"),
    INIT_FINANCIATED_PAYMENT_MOCK: "".concat(URL_API_MOCK, "cq/initFinanciatedPayment.json"),
    STATUS_FINANCIATED_PAYMENT: "".concat(URL_API, "ventas/pago/{cq}/financiado/status/{idSpo}/{idInterno}/"),
    STATUS_FINANCIATED_PAYMENT_MOCK: "".concat(URL_API_MOCK, "cq/statusFinanciatedPayment.json"),
    LIST_CQ: "".concat(URL_API, "ventas/pago/financiado"),
    LIST_CQ_MOCK: "".concat(URL_API_MOCK, "cq/listCq.json"),
    GET_PROVISIONAL_AGREEMENTS: "".concat(URL_API, "ventas/finalizar/{cq}/recuperar/precontrato"),
    GET_PROVISIONAL_AGREEMENTS_MOCK: "".concat(URL_API_MOCK, "cqv2/getProvisionalAgreement.json"),
    GET_PROVISIONAL_AGREEMENTS_TERMINALES_MOCK: "".concat(URL_API_MOCK, "cqv2/terminales/getProvisionalAgreement.json"),
    INIT_ONE_CLICK_CQ: "".concat(URL_API, "pedidos/oneClick/get/idCQ"),
    INIT_ONE_CLICK_CQ_MOCK: "".concat(URL_API_MOCK, "cqv2/initOneClickCQ.json"),
    COMMIT_ONE_CLICK_CQ: "".concat(URL_API, "pedidos/oneClick/commit"),
    COMMIT_ONE_CLICK_CQ_MOCK: "".concat(URL_API_MOCK, "cqv2/commitOneClickCQ.json")
  },
  SE: {
    SEND_TO_SE: "".concat(URL_API, "ventas/finalizar/backoffice"),
    SEND_TO_SE_MOCK: "".concat(URL_API_MOCK, "cqv2/backOffice.json")
  },
  WEBVIEW: {
    GET_NOVUM_WEBVIEW: "".concat(URL_API, "servicios/misservicios/sso/webview/{webViewName}"),
    GET_NOVUM_WEBVIEW_MOCK: "".concat(URL_API_MOCK, "webview/getNovumWebView.json")
  },
  JSON: {
    ERROR_NETPLUS: 'https://www.movistar.es/estaticos/Telco/adabyron/json/erroresNetplus.json',
    ERROR_NETPLUS_MOCK: "".concat(URL_API_MOCK, "json/errorNetplus.json"),
    ERROR_MESSAGE_NETPLUS: 'https://www.movistar.es/estaticos/Telco/adabyron/json/mensajesError.json',
    ERROR_MESSAGE_NETPLUS_MOCK: "".concat(URL_API_MOCK, "json/errorMessageNetplus.json"),
    NEXT_STEPS_LANDLINE: 'https://www.movistar.es/estaticos/Telco/adabyron/json/nextSteps/landLine.json',
    NEXT_STEPS_LANDLINE_MOCK: "".concat(URL_API_MOCK, "json/nextSteps/landLine.json"),
    NEXT_STEPS_LANDLINE_CERT: 'https://www.movistar.es.cert/cliente/venta/fusion/static/json/landLine.json',
    NEXT_STEPS_MOBILE_LINE: 'https://www.movistar.es/estaticos/Telco/adabyron/json/nextSteps/mobileLine.json',
    NEXT_STEPS_MOBILE_LINE_MOCK: "".concat(URL_API_MOCK, "json/nextSteps/mobileLine.json"),
    NEXT_STEPS_MOBILE_LINE_CERT: 'https://www.movistar.es.cert/cliente/venta/fusion/static/json/mobileLine.json',
    NEXT_STEPS_TV: 'https://www.movistar.es/estaticos/Telco/adabyron/json/nextSteps/tv.json',
    NEXT_STEPS_TV_MOCK: "".concat(URL_API_MOCK, "json/nextSteps/tv.json"),
    NEXT_STEPS_TV_CERT: 'https://www.movistar.es.cert/cliente/venta/fusion/static/json/tv.json',
    NEXT_STEPS_NETFLIX: 'https://www.movistar.es/estaticos/Telco/adabyron/json/nextSteps/netflix.json',
    NEXT_STEPS_NETFLIX_MOCK: "".concat(URL_API_MOCK, "json/nextSteps/netflix.json"),
    NEXT_STEPS_NETFLIX_CERT: 'https://www.movistar.es.cert/cliente/venta/fusion/static/json/netflix.json',
    NEXT_STEPS_SHIPPING_POT: 'https://www.movistar.es/estaticos/Telco/adabyron/json/nextSteps/shippingPot.json',
    NEXT_STEPS_SHIPPING_POT_MOCK: "".concat(URL_API_MOCK, "json/nextSteps/shippingPot.json"),
    NEXT_STEPS_SHIPPING_POT_CERT: 'https://www.movistar.es.cert/cliente/venta/fusion/static/json/shippingPot.json',
    NEXT_STEPS_PAYMENT_CONDITIONS_TERMINAL: "".concat(URL_API_MOCK, "json/nextSteps/paymentPotTerminal.json"),
    NEXT_STEPS_SHIPPING_POT_TERMINAL: "".concat(URL_API_MOCK, "json/nextSteps/shippingPotTerminal.json")
  }
};
exports.API = API;

var getUUID = function getUUID(idFront) {
  var v1options = {
    node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
    clockseq: 0x1234,
    msecs: new Date().getTime(),
    nsecs: 5678
  };
  var uuid = (0, _uuid.v1)(v1options);
  uuid = uuid.replace(/-/g, '');
  uuid = uuid.toUpperCase();
  return "idPeticion=".concat(idFront).concat(uuid);
};

exports.getUUID = getUUID;

//# sourceMappingURL=telcoApi.js.map